import script from "./MessageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageModal.vue?vue&type=script&setup=true&lang=js"

import "./MessageModal.vue?vue&type=style&index=0&id=8a99a77c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a99a77c"]])

export default __exports__